import { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  DialogActions,
  Button,
  InputAdornment,
  Typography,
  IconButton,
} from '@mui/material';
import { RHFSelect, RHFTextField } from '../hook-form';
import { LoadingButton } from '@mui/lab';
import { enqueueSnackbar } from 'notistack';
import { yupResolver } from '@hookform/resolvers/yup';
import FormProvider from '../hook-form/form-provider';
import { postRequest } from 'src/services';
import * as Yup from 'yup';
import { useForm, useFieldArray } from 'react-hook-form';

import { handleErrorMessages } from '../risk-management/risk-register/feching';
import Iconify from '../iconify';
import { Descriptions } from './dropdown-descirption';
import { calculateTotalCosts, reCalculateAllTotals } from './activity-models-calculations';

const ModalTotals = ({ PercentIcon, hideDetails }) => {
  return (
    <>
      {!hideDetails ? (
        <>
          <RHFTextField
            type="number"
            name="total_labor_cost"
            label="Total % of Labour Cost"
            disabled
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Box component="span" sx={{ color: 'text.disabled' }}>
                    {PercentIcon}
                  </Box>
                </InputAdornment>
              ),
            }}
          />
          <RHFTextField
            type="number"
            name="total_material_cost"
            label="Total % of Material Cost"
            disabled
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Box component="span" sx={{ color: 'text.disabled' }}>
                    {PercentIcon}
                  </Box>
                </InputAdornment>
              ),
            }}
          />
          <RHFTextField
            type="number"
            name="total_equipment_cost"
            label="Total % of Equipment Cost"
            disabled
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Box component="span" sx={{ color: 'text.disabled' }}>
                    {PercentIcon}
                  </Box>
                </InputAdornment>
              ),
            }}
          />
          <RHFTextField
            type="number"
            name="total_subcontractor_cost"
            label="Total % of Subcontractor Cost"
            disabled
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Box component="span" sx={{ color: 'text.disabled' }}>
                    {PercentIcon}
                  </Box>
                </InputAdornment>
              ),
            }}
          />
          <RHFTextField
            type="number"
            name="total_other_cost"
            label="Total % of Other Cost"
            disabled
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Box component="span" sx={{ color: 'text.disabled' }}>
                    {PercentIcon}
                  </Box>
                </InputAdornment>
              ),
            }}
          />
        </>
      ) : (
        <RHFTextField
          type="number"
          name="total_overall_cost"
          label="Total % on Overall"
          disabled
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Box component="span" sx={{ color: 'text.disabled' }}>
                  {PercentIcon}
                </Box>
              </InputAdornment>
            ),
          }}
        />
      )}
    </>
  );
};

export default ModalTotals;
